import GoogleMap from 'whq-google-map'
import mapStyles from './mapStyles'

const loadLocationsMap = () => {
    const mapCanvas = document.querySelector('.locations-map')
    const siteHeader = document.querySelector('.site-header')
    const locationHeader = document.querySelector('.location-header')
    const locationViewer = document.querySelector('.locations-viewer')

    function resize (event) {
        const height = window.innerHeight - (siteHeader.offsetHeight + locationHeader.offsetHeight)
        locationViewer.style.height = `${height}px`
    }

    if (mapCanvas) {
        const mapMarkerData = JSON.parse(mapCanvas.getAttribute('data-markers'))
        const mapMarkers = Object.keys(mapMarkerData).map(marker => mapMarkerData[marker])

        const locationsMap = new GoogleMap({
            apiKey: 'AIzaSyDlADUXC4UM_xSz41Y0wcgqLh9ScfRdj_0',
            element: mapCanvas,
            initialCoords: { lat: 40.2672, lng: -86.1349 },
            zoom: 7,
            markerIcon: '/wp-content/themes/silverbirch/img/map-marker.png',
            markers: mapMarkers,
            markerClick: {
                enabled: true,
                zoom: 9,
                centerOnMarker: true,
                bindSelector: '.location-teaser',
                boundElementContainer: '.location-results',
                activeClass: 'active'
            },
            styles: mapStyles
        })

        locationsMap.init()

        window.addEventListener('resize', resize)
        resize()
    }

    const locationTeasers = document.querySelectorAll('.location-teaser a')

    if (locationTeasers.length > 0) {
        locationTeasers.forEach(teaser => {
            teaser.addEventListener('click', event => event.stopPropagation())
        })
    }
}

export default loadLocationsMap



// WEBPACK FOOTER //
// ./js/locationsMap.js